export default "__VITE_ASSET__iqlldbKQ__"